module.exports = __webpack_public_path__ + "img/hr-puberty-decal-14.c5133660.png";